define(
	'Tavanoteam.TavanoTeam_MerchZone_Extension.MerchZone'
	, [
		'MerchZone.View'
	]
	, function (
		MerchZoneView
	) {

		'use strict';

		return {

			mountToApp: function mountToApp(container) {

				container.getComponent('CMS').registerCustomContentType({

					/* this property value MUST be lowercase */
					id: 'cct_tavanoteam_smartmerchzone'

					, options: {
						container: container
					}

					/* The view to render the CCT */
					, view: MerchZoneView
				});
			}
		};
	}
);
